import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useWorkspaceStore = defineStore('workspace', () => {
  const currentWorkspace = ref(null);

  const {
    items: workspaces,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroyItem: destroy,
  } = createBaseStore('api/workspaces/workspace');

  return {
    workspaces,
    currentWorkspace,
    fetch,
    destroy,
    update,
    store,
  };
});
